module.exports = __webpack_public_path__ + "static/media/TikTok.d292ff89.svg";